import { render, staticRenderFns } from "./advanceCompanyOfficersSettings.vue?vue&type=template&id=61a19816"
import script from "./advanceCompanyOfficersSettings.vue?vue&type=script&lang=js"
export * from "./advanceCompanyOfficersSettings.vue?vue&type=script&lang=js"
import style0 from "./advanceCompanyOfficersSettings.vue?vue&type=style&index=0&id=61a19816&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports